
import type { PropType } from 'vue'
import type { Tab } from '../models/components/tab'

import { defineComponent } from 'vue'

import { ColorEnum } from '../enums'
import { UiRippleInk } from './keen-ui'

import { EpbText } from './shared/epb-text'

export default defineComponent({
  name: 'EpbTabs',
  components: {
    EpbText,
    UiRippleInk,
  },
  props: {
    tabs: Array as PropType<Array<Tab>>,
    selectedTabId: {
      type: String,
      required: true,
    },
    fullWidth: Boolean,
    color: {
      type: String as PropType<'neutral' | 'primary'>,
      default: 'neutral',
    },
  },
  setup() {
    return {
      ColorEnum,
    }
  },
  watch: {
    selectedTabId: {
      handler(): void {
        if (
          !this.tabs.find(tabConfig => tabConfig.id === this.selectedTabId && !tabConfig.disabled)
        ) {
          const firstTabEnabled = this.tabs.find(tabConfig => !tabConfig.disabled)
          this.updateSelectedTabId(firstTabEnabled ? firstTabEnabled.id : '')
        }
      },
      immediate: true,
    },
  },
  methods: {
    getTabClasses(tab: any): string[] {
      const tabClasses = []
      if (tab.disabled) {
        tabClasses.push('epb-tabs__tab--disabled')
      }
      if (tab.closable) {
        tabClasses.push('epb-tabs__tab--closable')
      }
      if (this.selectedTabId === tab.id) {
        tabClasses.push('epb-tabs__tab--selected')
      }
      if (tab.color) {
        tabClasses.push(`epb-tabs__tab--${tab.color}`)
      }
      return tabClasses
    },
    onTabClick(tabId: string): void {
      if (tabId !== this.selectedTabId) {
        this.updateSelectedTabId(tabId)
      }
    },
    updateSelectedTabId(tabId: string): void {
      this.$emit('update:selectedTabId', tabId)
      this.$emit('updateSelectedTabId', tabId)
    },
  },
})
